import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_CalocusScoringSheet = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_CalocusScoringSheet' className='file-pdf-document'>
            <div className='file-template'>



                <h3>CALOCUS WORKSHEET
                </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Rater Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtRaterName" name="txtRaterName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id="txtDate" name="txtDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please check the applicable ratings within each dimension and record the score in the lower right hand corner. Total
                    your score and determine the recommended level of care using either the Placement Grid or the Decision Tree.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I. Risk of Harm</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_1_1" name="rb_1" className='add-only' value="1" /> 1. Low Potential for Risk of Harm
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_1_2" name="rb_1" className='add-only' value="2" /> 2. Some Potential for Risk of Harm
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_1_3" name="rb_1" className='add-only' value="3" /> 3. Significant Potential for Risk of Harm
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_1_4" name="rb_1" className='add-only' value="4" /> 4. Serious Potential for Risk of Harm
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_1_5" name="rb_1" className='add-only' value="5" /> 5. Extreme Potential for Risk of Harm
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Score : &nbsp; <input type="text" id="txt_1_1" name="txt_1_1" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>II. Functional Status </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_2_1" name="rb_2" className='add-only' value="1" /> 1. Minimal Impairment
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_2_2" name="rb_2" className='add-only' value="2" /> 2. Mild Impairment
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_2_3" name="rb_2" className='add-only' value="3" /> 3. Moderate Impairment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_2_4" name="rb_2" className='add-only' value="4" /> 4. Serious Impairment
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_2_5" name="rb_2" className='add-only' value="5" /> 5. Severe Impairment
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Score : &nbsp;<input type="text" id="txt_1_2" name="txt_1_2" className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>III. Co-Morbidity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_3_1" name="rb_3" className='add-only' value="1" /> 1. No Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_3_2" name="rb_3" className='add-only' value="2" /> 2. Minor Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_3_3" name="rb_3" className='add-only' value="3" /> 3. Significant Co-Morbidity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_3_4" name="rb_3" className='add-only' value="4" /> 4. Major Co-Morbidity
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_3_5" name="rb_3" className='add-only' value="5" /> 5. Severe Co-Morbidity
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Score : &nbsp;<input type="text" id="txt_1_3" name="txt_1_3" className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>IV-A. Recovery Environment - Level of Stress</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_4_1" name="rb_4" className='add-only' value="1" /> 1. Minimally Stressful Environment
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_4_2" name="rb_4" className='add-only' value="2" /> 2. Mildly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_4_3" name="rb_4" className='add-only' value="3" /> 3. Moderately Stressful Environment
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_4_4" name="rb_4" className='add-only' value="4" /> 4. Highly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_4_5" name="rb_4" className='add-only' value="5" /> 5. Extremely Stressful Environment
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Score : &nbsp;<input type="text" id="txt_1_4" name="txt_1_4" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>IV-B. Recovery Environment - Level of Support</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_5_1" name="rb_5" className='add-only' value="1" /> 1. Highly Supportive Environment
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_5_2" name="rb_5" className='add-only' value="2" /> 2. Supportive Environment
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_5_3" name="rb_5" className='add-only' value="3" /> 3. Limited Support in Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_5_4" name="rb_5" className='add-only' value="4" /> 4. Minimal Support in Environment
                        </td>
                        <td className='w-500'>
                            <input type="radio" id="rb_5_5" name="rb_5" className='add-only' value="5" /> 5. No Support in Environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Score : &nbsp;<input type="text" id="txt_1_5" name="txt_1_5" className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>V. Resiliency and Treatment History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_6_1" name="rb_6" className='add-only' value="1" /> 1. Full Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_6_2" name="rb_6" className='add-only' value="2" /> 2. Significantly Resilient and/or Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_6_3" name="rb_6" className='add-only' value="3" /> 3. Moderate or Equivocal Response to Treatment And
                            Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_6_4" name="rb_6" className='add-only' value="4" /> 4. Poor Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_6_5" name="rb_6" className='add-only' value="5" /> 5. Negligible Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Score : &nbsp;<input type="text" id="txt_1_76" name="txt_1_76" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>VI-A. Acceptance and Engagement - Child/Adolescent</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_7_1" name="rb_7" className='add-only' value="1" /> 1. Optimal
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_7_2" name="rb_7" className='add-only' value="2" /> 2. Constructive
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_7_3" name="rb_7" className='add-only' value="3" /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_7_4" name="rb_7" className='add-only' value="4" /> 4. Adversarial
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_7_5" name="rb_7" className='add-only' value="5" /> 5. Inaccessible
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>Score : &nbsp;<input type="text" id="txt_1_7" name="txt_1_7" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>VI-B. Acceptance and Engagement - Parent/Primary Caretaker</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_8_1" name="rb_8" className='add-only' value="1" /> 1. Optimal
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_8_2" name="rb_8" className='add-only' value="2" /> 2. Constructive
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_8_3" name="rb_8" className='add-only' value="3" /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_8_4" name="rb_8" className='add-only' value="4" /> 4. Destructive
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_8_5" name="rb_8" className='add-only' value="5" /> 5. Inaccessible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Score : &nbsp;<input type="text" id="txt_1_8" name="txt_1_8" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Composite Score</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Level of Care Recommendation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txt_9_1" name="txt_9_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txt_10_1" name="txt_10_1" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>SCORING SHEET</h3>

                <h4>Child and Adolescent Level of Care Utilization System</h4>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>A. Clinical Level of Care Recommendation</span>
                            <span className='small'>(Assign before using CALOCUS)</span>
                        </td>
                        <td className='w-375'><span className='eleHeader'>B. Calculation of Composite CALOCUS Score</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txt_11" name="txt_11" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txt_12" name="txt_12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-425'><span className='eleHeader'>Dimension</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Dimension Rating</span>
                            <span className='small'>(cricle score)</span>
                        </td>
                        <td className='w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-425'>1. Risk of Harm </td>
                        <td className='w-150'>
                            <input type="radio" id="rb_13_1" name="rb_13" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_13_2" name="rb_13" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_13_3" name="rb_13" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_13_4" name="rb_13" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_13_5" name="rb_13" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_13" name="txt_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-425'>2. Functional Status </td>
                        <td className='w-150'>
                            <input type="radio" id="rb_14_1" name="rb_14" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_14_2" name="rb_14" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_14_3" name="rb_14" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_14_4" name="rb_14" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_14_5" name="rb_14" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_14" name="txt_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-425'>3. Co-Morbidity</td>
                        <td className='w-150'>
                            <input type="radio" id="rb_15_1" name="rb_15" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_15_2" name="rb_15" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_15_3" name="rb_15" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_15_4" name="rb_15" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_15_5" name="rb_15" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_15" name="txt_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>4. Recovery Environment </td>
                    </tr>
                    <tr>
                        <td className='w-425'>Environmental Stressors</td>
                        <td className='w-150'>
                            <input type="radio" id="rb_16_1" name="rb_16" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_16_2" name="rb_16" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_16_3" name="rb_16" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_16_4" name="rb_16" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_16_5" name="rb_16" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_16" name="txt_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-425'>Environmental Support</td>
                        <td className='w-150'>
                            <input type="radio" id="rb_17_1" name="rb_17" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_17_2" name="rb_17" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_17_3" name="rb_17" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_17_4" name="rb_17" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_17_5" name="rb_17" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_17" name="txt_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-425'>5. Resiliency and Treatment History</td>
                        <td className='w-150'>
                            <input type="radio" id="rb_18_1" name="rb_18" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_18_2" name="rb_18" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_18_3" name="rb_18" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_18_4" name="rb_18" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_18_5" name="rb_18" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_18" name="txt_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>6. Acceptance and Engagement</td>
                    </tr>
                    <tr>
                        <td className='w-425'>Child/Adolescent </td>
                        <td className='w-150'>
                            <input type="radio" id="rb_19_1" name="rb_19" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_19_2" name="rb_19" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_19_3" name="rb_19" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_19_4" name="rb_19" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_19_5" name="rb_19" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_19" name="txt_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-425'>Parent and/or primary care taker</td>
                        <td className='w-150'>
                            <input type="radio" id="rb_20_1" name="rb_20" className='add-only' value="1" /> 1 &nbsp;
                            <input type="radio" id="rb_20_2" name="rb_20" className='add-only' value="2" /> 2 &nbsp;
                            <input type="radio" id="rb_20_3" name="rb_20" className='add-only' value="3" /> 3 &nbsp;
                            <input type="radio" id="rb_20_4" name="rb_20" className='add-only' value="4" /> 4 &nbsp;
                            <input type="radio" id="rb_20_5" name="rb_20" className='add-only' value="5" /> 5
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txt_20" name="txt_20" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    (Note: please record the higher of the two scores)
                </p>
                <p className='w-750'>
                    Note: Bold indicates independent criteria-requires automatic admission to a higher level of care regardless of
                    combined score. A score of 4 results in placement at level 5 and a score of 5 results in placement at level six.
                </p>
                <p className='w-750'>
                    * = independent criteria may be waived if sum of IV-A and IV-B scores equal 2.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>COMPOSITE CALOCUS SCORES</span> <span className='small'>(add right column)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtCalousScore" name="txtCalousScore" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>C. CALOCUS Derived Level of Care Recommendation</span> <span className='small'>(Consult Grid and Decision Tree)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txt_21" name="txt_21" className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>D. Actual (Disposition) Level of Care </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txt_22" name="txt_22" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Reason for Variance from CALOCUS Level of Care Recommendation </span>
                    <textarea id="txt_23" name="txt_23" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Patient/Family Name:</span>
                            <input type="text" id="txt_24" name="txt_24" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Scoring:</span>
                            <input type='date' id="txt_241" name="txt_241" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Scorer:</span>
                            <input type="text" id="txt_25" name="txt_25" className='add-only' />
                        </td>
                    </tr>
                </table>




            </div>
        </form >

    )
}  
